const defaultStorageKey = 'defaulteTrainerStore'
const storageUserKey = 'etrainerUser'

let isPlus = window.location.href.includes('plus/verwaltung')
let keyDefault = isPlus ? 'plusDefaulteTrainerStore' : defaultStorageKey
let keyStorage = isPlus ? 'plusEtrainerUser' : storageUserKey

export const resetDefaultStore = () => 
    localStorage.setItem(keyDefault, '')


export const removeCurrentStorageUser = () => localStorage.removeItem(getCurrentStorageUser())

export const getCurrentStorageUser = () =>
    localStorage.getItem(keyStorage) || keyDefault

export const currentStorageUserIsDefault = () => {
    const currentUser = getCurrentStorageUser()
    return currentUser === keyDefault
}

export const setCurrentStorageUser = (un) => localStorage.setItem(keyStorage, un)
